<template>
  <div class="v-application--wrap">
    <CustomDialog />
    <GlobalLoading />
    <LogIn />
    <the-layout-toolbar @toggleDrawer="isDrawerOpen = !isDrawerOpen" />
    <the-layout-drawer v-if="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs" />
    <the-layout-content />
    <!-- <the-layout-fab /> -->
    <the-layout-to-top-fab />
    <the-layout-footer />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TM from "@/api/ticket-management";
import TheLayoutToolbar from "./TheLayoutToolbar.vue";
import TheLayoutDrawer from "./TheLayoutDrawer.vue";
import TheLayoutContent from "./TheLayoutContent.vue";
import TheLayoutToTopFab from "./TheLayoutToTopFab.vue";
import TheLayoutFooter from "./TheLayoutFooter.vue";
import { CurrentReservedMixins } from "@/shared/mixins"
import LogIn from "./LogIn.vue";

let apiUrl = process.env.VUE_APP_API + process.env.VUE_APP_API_TM;
window.isPopState = false
window.orderCanceled = false

const confirmToBack = async (e, $this) => {
  e.preventDefault()
  e.stopPropagation()

  if (window.isPopState) return
  window.isPopState = true
  const routes = ['Activity', 'Order1', 'ConfirmSt', 'SelSt', 'Order2', 'Order3', 'Done']

  if ($this.isGoback || $this.isPopState || routes.indexOf($this.$route.name) === -1) {
    window.isPopState = false;
    return
  }

  if (!$this.prevRoute || routes.indexOf($this.prevRoute.name) === -1 && !$this.currentRoute || routes.indexOf($this.currentRoute.name) === -1 && routes.indexOf($this.$route.name) === -1) {
    $this.isGoback = false
    $this.$forceUpdate()
  }

  window.prevRoute = $this.prevRoute
  window.currentRoute = $this.currentRoute
  window.$route = $this.$route
  window.isSeated = $this.areaAssignment && $this.seatAssignment
  const routeName = window.currentRoute ? window.currentRoute.name : window.$route.name

  $this.setPopState(true);
  document.body.classList.add("is-popstate");
  $this.isGoback = true
  if (["ConfirmSt", "SelSt"].includes(routeName) || (routeName === "Order2" && !window.isSeated && (!prevRoute || prevRoute.name !== 'Order3'))) {
    $this.showDialog({
      title: $this.$t('layout_notification_title'),
      content: $this.$t('layout_notification_content'),
      buttons: [
        {
          text: $this.$t('layout_notification_cancel'),
          style: {
            block: true,
            outlined: true,
            color: "primary",
          },
          action: () => {
            $this.$router.push({
              name: routeName,
              params: { eventId: window.$route.params.eventId, sessionId: window.$route.params.sessionId },
            }).catch(error => { });

            $this.initPopState()
          },
        },
        {
          text: $this.$t('layout_notification_confirm'),
          style: {
            depressed: true,
            block: true,
            outlined: false,
            color: "primary",
          },
          action: async () => {
            const { data } = await TM.ticketRelease({
              orderId: $this.reserveResponse.orderId,
              culturePointInfo: {},
            });
            if (data.errCode === "00") {
              $this.resetCulturePoint();
              $this.resetOrderState();
              $this.setPageData(null);
              $this.$router.push({
                name: "Order1",
                params: { sessionId: window.$route.params.sessionId },
              }).catch(error => { })
              $this.initPopState()
            }
          },
        },
      ],
    });

    return
  }

  switch (routeName) {
    case 'Order3':
      if (window.isProcess) {
        alert($this.$t('leave_order'))
        await $this.cancelTicket($this)
      }
      else {
        $this.$router.push({
          name: 'Order2',
          params: { eventId: window.$route.params.eventId, sessionId: window.$route.params.sessionId },
        }).catch(error => { })
      }
      break
    case 'Order2':
      if (window.isProcess) {
        alert($this.$t('leave_order'))
        await $this.cancelTicket($this)
      }
      if (window.isSeated && !window.isProcess && !prevRoute.name === 'Order3') {
        $this.$router.push({
          name: 'ConfirmSt',
          params: { eventId: window.$route.params.eventId, sessionId: window.$route.params.sessionId },
        }).catch(error => { })
      }
      break
    case 'Order1':
      $this.$router.push({
        name: "Activity",
        params: { id: window.$route.params.eventId },
      }).catch(error => { })
      break
    case 'Done':
    case 'Activity':
      $this.$router.push({
        name: "Index",
      }).catch(error => { })
      break
    default:
      $this.$router.push({
        name: "Order1",
        params: { eventId: window.$route.params.eventId, sessionId: window.$route.params.sessionId },
      }).catch(error => { })
      break
  }

  $this.initPopState()
  return false
}

export default {
  name: "TheLayout",
  mixins: [CurrentReservedMixins],
  components: {
    TheLayoutToolbar,
    TheLayoutDrawer,
    TheLayoutContent,
    TheLayoutToTopFab,
    TheLayoutFooter,
    LogIn
  },
  computed: {
    ...mapGetters({
      updateResponse: "order/updateResponse",
      reserveResponse: "order/reserveResponse",
      areaAssignment: "order/areaAssignment",
      seatAssignment: "order/seatAssignment",
      isPopState: "order/isPopState",
      campaign: "event/campaign",
    })
  },
  data() {
    return {
      isGoback: false,
      currentRoute: "",
      prevRoute: "",
    }
  },
  watch: {
    '$route': function ($route, oldRoute) {
      this.currentRoute = $route;
      this.prevRoute = oldRoute;
      this.$forceUpdate()
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.confirmToReload);
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.confirmToReload);
    });
  },
  /**
  mounted() {
    const $this = this
    window.addEventListener("popstate", (e) => confirmToBack(e, $this), false);
  },
  */
  beforeDestroy() {
    // window.removeEventListener("popstate", (e) => confirmToBack(e), false);
    window.removeEventListener("beforeunload", this.confirmToReload);
  },
  methods: {
    ...mapActions({
      showDialog: "dialog/show",
      resetOrderState: "order/resetOrderState",
      setPopState: "order/setPopState",
      setPageData: "order/setPageData",
      setTimer: "order/setTimer",
      reserveTicket: "order/reserveTicket",
      resetCulturePoint: "culturePoint/resetCulturePoint",

    }),
    async cancelTicket($this) {
      const { data } = await TM.ticketRelease({
        orderId: $this.reserveResponse.orderId,
        culturePointInfo: {},
      });

      if (data.errCode === "00") {
        $this.resetCulturePoint();
        $this.resetOrderState();
        $this.setPageData(null);
        $this.$router.push({
          name: "Order1",
          params: { sessionId: window.$route.params.sessionId },
        }).catch(error => { })
      }
      window.orderCanceled = true
      window.isProcess = false
    },
    initPopState() {
      this.setPopState(false)
      this.isGoback = false
      this.currentRoute = null
      this.prevRoute = null
      window.prevRoute = null
      window.currentRoute = null
      window.$route = null
      document.body.classList.remove("is-popstate");
      window.isPopState = false
      this.$forceUpdate()
    },
    confirmToReload(e) {
      let routes = ['ConfirmSt', 'SelSt', 'Order2', 'Order3'];

      if (routes.indexOf(this.currentRoute.name) > -1 && !window.isErrorToBack) {
        e.preventDefault();
        e.returnValue = "";
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    console.log('Layout beforeRouteLeave', to.name, from.name)
  }
};
</script>
